import { Form, Input } from "antd";
import { ChangeEvent, useCallback, useState } from "react";
import { onlyLatinCharsDigitsSpecialSymbolsRule } from "../../../../utils/form.constants";

export const ConfirmPasswordForms = () => {
  const [value, setValue] = useState("");

  const onChange = useCallback(
    ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
      setValue(value.toString());
    },
    []
  );

  const shouldValidate = value.length >= 6;

  const handleKeyDown = (event: any) => {
    if (event.key === " ") {
      event.preventDefault();
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "24px",
      }}
    >
      <Form.Item
        label="New Password"
        name="password"
        validateTrigger="onBlur"
        rules={[
          onlyLatinCharsDigitsSpecialSymbolsRule,
          {
            required: true,
            validateTrigger: "onBlur",
            message: "This field is required",
          },
          {
            validator: (_, value) => {
              if (!value) return Promise.resolve();
              if (value.length >= 6) {
                return Promise.resolve();
              }
              return Promise.reject(new Error("6 characters at least"));
            },
          },
        ]}
        initialValue=""
        hasFeedback={shouldValidate}
        className="input-password"
      >
        <Input.Password
          readOnly
          onFocus={(e) => e.currentTarget.removeAttribute("readonly")}
          onChange={onChange}
          placeholder="Password with at least 6 characters (case sensitive)"
          size="large"
          onKeyDown={handleKeyDown}
        />
      </Form.Item>
      <Form.Item
        label="Confirm Password"
        name="confirm"
        dependencies={["password"]}
        validateTrigger="onBlur"
        hasFeedback={shouldValidate}
        rules={[
          onlyLatinCharsDigitsSpecialSymbolsRule,
          {
            required: true,
            validateTrigger: "onBlur",
            message: "This field is required",
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue("password") === value) {
                return Promise.resolve();
              }
              return Promise.reject(
                new Error("The two passwords that you entered do not match!")
              );
            },
          }),
        ]}
        className="input-password"
      >
        <Input.Password
          readOnly
          onFocus={(e) => e.currentTarget.removeAttribute("readonly")}
          placeholder="Re-enter password"
          size="large"
          onKeyDown={handleKeyDown}
        />
      </Form.Item>
    </div>
  );
};
